import { render, staticRenderFns } from "./orderDelivery.vue?vue&type=template&id=634460e5&scoped=true"
import script from "./orderDelivery.vue?vue&type=script&lang=js"
export * from "./orderDelivery.vue?vue&type=script&lang=js"
import style0 from "./orderDelivery.vue?vue&type=style&index=0&id=634460e5&lang=scss&scoped=true"
import style1 from "./orderDelivery.vue?vue&type=style&index=1&id=634460e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634460e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634460e5')) {
      api.createRecord('634460e5', component.options)
    } else {
      api.reload('634460e5', component.options)
    }
    module.hot.accept("./orderDelivery.vue?vue&type=template&id=634460e5&scoped=true", function () {
      api.rerender('634460e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderDelivery.vue"
export default component.exports